import React, { useState } from 'react'

import PropTypes from 'prop-types'

function ChallengesArea({ challenges, tags, onTagsChange: handleTagsChange, isPrintable, isFree }) {
  const [interactedChallenges, setInteractedChallenges] = useState(new Set())

  const handleChallengeParticipationChange = (event, challenge) => {
    setInteractedChallenges(prev => new Set(prev).add(challenge.tag))

    if (tags.includes(challenge.tag) && !event.target.checked) {
      return handleTagsChange(tags.filter((tag) => tag !== challenge.tag))
    } if (!tags.includes(challenge.tag) && event.target.checked) {
      return handleTagsChange(tags.concat(challenge.tag))
    }
  }

  const handleDisabledCheckboxClick = (challenge) => {
    setInteractedChallenges(prev => new Set(prev).add(challenge.tag))
  }

  if (!Array.isArray(challenges) || challenges.length === 0) {
    return null
  }

  const filteredChallenges = challenges
    .filter(challenge => challenge && challenge.tag)
    .filter(challenge => (isPrintable ? challenge.printable_type : challenge.cg_type))
    .filter(challenge => !challenge.free_models || isFree)

  if (filteredChallenges.length === 0) {
    return null
  }

  return (
    <div className="publisher-area publisher-area--challenges">
      <div className="card">
        <div className="l-inner">
          <div className="section-heading">Challenge Participation</div>
          <div className="challenges-section">
            {filteredChallenges.map(challenge => {
              const hasRuleViolations = (challenge.rule_violations?.length || 0) > 0
              const isDisabled = challenge.item_hard_rejected || hasRuleViolations
              const hasInteracted = interactedChallenges.has(challenge.tag)
              const showIneligibleMessage = hasRuleViolations && hasInteracted

              const interactiveProps = isDisabled ? {
                role: 'button',
                tabIndex: 0,
                onKeyDown: (e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    handleDisabledCheckboxClick(challenge)
                  }
                },
              } : {}

              return (
                <div
                  className="challenges-section__participate-check"
                  key={challenge.tag}
                  onClick={() => isDisabled && handleDisabledCheckboxClick(challenge)}
                  {...interactiveProps}
                >
                  <input
                    type="checkbox"
                    id={`challenge-${challenge.tag}`}
                    className="checkbox"
                    disabled={isDisabled}
                    checked={tags.includes(challenge.tag)}
                    onChange={(event) => handleChallengeParticipationChange(event, challenge)}
                  />
                  <label
                    htmlFor={`challenge-${challenge.tag}`}
                    aria-disabled={isDisabled}
                  >
                    Participate in <strong>{challenge.title}</strong> challenge
                  </label>
                  {showIneligibleMessage && (
                    <span className="challenges-section__ineligible-message">
                      This model does not meet the challenge criteria.
                      {' '}<a href={challenge.path} target="_blank" rel="noreferrer">View Challenge Rules</a>
                    </span>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

ChallengesArea.propTypes = {
  challenges: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  onTagsChange: PropTypes.func.isRequired,
  isPrintable: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
}

export default ChallengesArea
